import { render, staticRenderFns } from "./AddTargetGroupBoosters.vue?vue&type=template&id=3771c18e"
import script from "./AddTargetGroupBoosters.vue?vue&type=script&lang=js"
export * from "./AddTargetGroupBoosters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports